import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Flex } from 'foundations-components/components/Flex';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { ErrorBoundary } from 'reporting-ui-components/reports/decorators/ErrorBoundaryDecorator';
import { trackReportRecommendationClick, useReportTemplateRecommendations } from 'reporting-discover-components/utils/recommendations/reportRecommendationUtils';
// @ts-expect-error Untyped import
import { EVENTS } from '../../lib/usageTracker';
import { useSuiteTemplates } from '../../utils/useSuiteTemplates';
import { getRecentlyViewedSubAppKeysForHomePage } from '../../utils/recentlyViewedTemplatesUtils';
import { getUserInfo } from '../../selectors/gatesSelector';
import DescriptiveReportCard from './DescriptiveReportCard';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoErrorComponent = () => null;
const NUM_RECOMMENDATIONS = 4;
const TemplateRecommendationSection = ({
  suiteId
}) => {
  const suiteTemplates = useSuiteTemplates(suiteId);
  const eligibleTemplates = useMemo(() => {
    const recentlyViewedSubApps = getRecentlyViewedSubAppKeysForHomePage(suiteId);
    return suiteTemplates.filter(template => !recentlyViewedSubApps.includes(template.getIn(['suiteNavData', 'navItemId'])));
  }, [suiteId, suiteTemplates]);
  const userInfo = useSelector(getUserInfo);
  const results = useReportTemplateRecommendations(eligibleTemplates, userInfo);
  if (results.isEmpty()) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "700",
    children: [/*#__PURE__*/_jsxs(Flex, {
      marginBlockEnd: "400",
      gap: "200",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        marginBlockEnd: "0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.collectionHomes.recommendations"
        })
      }), /*#__PURE__*/_jsx(Badge, {
        use: "beta",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.analysis.beta"
        })
      })]
    }), /*#__PURE__*/_jsx(CardGrid, {
      gutterSize: 16,
      columnSize: 320,
      children: results.take(NUM_RECOMMENDATIONS).map(template => {
        const navData = template.get('suiteNavData');
        const {
          navItemId: subAppKey,
          tabId
        } = navData.toJS();
        return /*#__PURE__*/_jsx(DescriptiveReportCard, {
          useCompact: true,
          name: template.get('name'),
          onClick: () => {
            trackReportRecommendationClick(template);
          },
          subAppKey: subAppKey,
          tabId: tabId,
          trackingEvent: EVENTS.clickRecommendedReportsCard
        }, `${subAppKey}-${tabId}`);
      })
    }, `${suiteId}-recommendations`)]
  });
};
const RecommendationsWithErrorBoundary = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  ErrorComponent: NoErrorComponent,
  children: /*#__PURE__*/_jsx(TemplateRecommendationSection, Object.assign({}, props))
});
export default RecommendationsWithErrorBoundary;